import React, { useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import add from 'date-fns/add';
import AppSelect from '../../../shared/components/app-select/AppSelect';
import {
  formatDate,
  getNewDate,
  isEmpty,
} from '../../../shared/helper-utils/appUtils';
import {
  API_DATE_FORMAT,
  TODAY_DATE,
} from '../../../shared/constants/Constants';
import AppDatePicker from '../../../shared/components/app-date-picker/AppDatePicker';
import AppButton from '../../../shared/components/app-button/AppButton';
import {
  getStringFromLS,
  getUserAgentId,
} from '../../../shared/helper-utils/localStorage';
import { APP_USER_AUTH } from '../../../saas/AppStorageStaticNames';

const REPORT_TYPE = [
  {
    label: 'Pax Wise Series Fare Report',
    value: 'GETPAXWISESERIESFAREREPORTFORAGENT',
  },
  {
    label: 'Series Fare Sale Report',
    value: 'GETSERIESFAREREPORTFORAGENT',
  },
];

function SeriesSaleReport() {
  const [reportType, setReportType] = useState(
    'GETPAXWISESERIESFAREREPORTFORAGENT',
  );
  const [fromDate, setFromDate] = useState(getNewDate(TODAY_DATE));
  const [toDate, setToDate] = useState(
    add(getNewDate(TODAY_DATE), { days: 1 }),
  );

  // eslint-disable-next-line consistent-return
  const handleGetSeriesSaleReport = () => {
    try {
      if (!isEmpty(fromDate) && !isEmpty(toDate) && !isEmpty(reportType)) {
        const userAuth = getStringFromLS(APP_USER_AUTH);
        const formattedFromDate = formatDate(
          getNewDate(fromDate),
          API_DATE_FORMAT,
        );
        const formattedToDate = formatDate(getNewDate(toDate), API_DATE_FORMAT);
        let link = `${
          // eslint-disable-next-line no-undef
          process.env.REACT_APP_MAIN_URL
        }v2dispatch.jsp?sessiontoken=${userAuth}&opid=RP056&format=html&period=PERIODIC&agentid=${getUserAgentId()}&txtype=SeriesFareSales&responseformat=excel`;
        link += `&fromdate=${formattedFromDate}&todate=${formattedToDate}&actioncode=${reportType}`;
        const element = document.createElement('a');
        element.href = link;
        element.target = '_blank';
        element.download = `Sale_Report_from_${formattedFromDate}_to_${formattedToDate}.xls`;
        element.click();
      }
    } catch (error) {
      return undefined;
    }
  };
  return (
    <div className="mt-4 fs-14">
      <Row className="spacing-8">
        <Col lg={3} md={3} sm={6} xs={12}>
          <AppSelect
            label="Type"
            options={REPORT_TYPE}
            placeholder=""
            selectedValue={reportType}
            onSelect={(d) => setReportType(d.value)}
            isClearable={false}
          />
        </Col>
        <Col lg={3} md={3} sm={6} xs={12}>
          <AppDatePicker
            label="From Date"
            labelClassName="agent-series-fare_date-label"
            customClassName="agent-series-fare_date-picker"
            placeholder=""
            selectedDate={fromDate}
            onChange={(date) => setFromDate(date)}
          />
        </Col>
        <Col lg={3} md={3} sm={6} xs={12}>
          <AppDatePicker
            label="To Date"
            labelClassName="agent-series-fare_date-label"
            customClassName="agent-series-fare_date-picker"
            placeholder=""
            selectedDate={toDate}
            onChange={(date) => setToDate(date)}
          />
        </Col>
        <Col lg={3} md={3} sm={6} xs={12}>
          <AppButton
            btnText="Get Report"
            variant="secondary"
            onClick={handleGetSeriesSaleReport}
          />
        </Col>
      </Row>
    </div>
  );
}

export default SeriesSaleReport;
